// extracted by mini-css-extract-plugin
export default {"productCarousel":"y0-z"};